import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDeepLTranslated } from '../../hooks/useDeepLTranslated';

/* 선택 옵션 display section - used inside Card across:
   ReservationDetail, TransferComplete, TourComplete, TransferPayment, TourPayment
   options: [{ label, value, price }] where price is formatted string like "(+9,900원)" or null
   variant: 'default' (service pages), 'admin' (admin detail pages) */
export default function OptionsSection({ options = [], variant = 'default' }) {
  const { t } = useTranslation();
  const isAdmin = variant === 'admin';

  // 백엔드에서 내려오는 옵션 label/value 한국어를 렌더 시점 DeepL 번역.
  // label, value, price 순으로 플랫하게 수집 후 인덱스로 다시 매핑.
  // 어드민(한국 운영자 전용)은 번역 자체를 스킵 — i18n race 로 일본어/중국어 누출 방지.
  const bundle = useMemo(() => {
    if (isAdmin) return [];
    const out = [];
    options.forEach((opt) => {
      out.push(opt.label || '', opt.value || '', opt.price || '');
    });
    return out;
  }, [options, isAdmin]);
  const translated = useDeepLTranslated(bundle);
  const tOptions = isAdmin
    ? options
    : options.map((opt, i) => ({
        ...opt,
        label: translated[i * 3] || opt.label,
        value: translated[i * 3 + 1] || opt.value,
        price: translated[i * 3 + 2] || opt.price,
      }));

  return (
    <>
      <h3 className="text-lg font-bold text-mono-900">{t('booking.selected_options')}</h3>
      <div className="flex flex-col">
        {tOptions.map((opt, i) => (
          <div key={i} className={`flex ${isAdmin ? 'items-baseline gap-0' : 'items-center gap-4 sm:gap-6'} py-1.5`}>
            <span className={`text-2sm font-medium text-mono-500 ${isAdmin ? 'w-[100px]' : 'w-[80px] sm:w-[120px]'} shrink-0`}>{opt.label}</span>
            <div className={`flex items-center ${isAdmin ? 'gap-1' : 'gap-1'} min-w-0`}>
              {opt.value && <span className="text-2sm font-medium text-mono-900">{opt.value}</span>}
              {opt.price && <span className="text-2sm font-medium text-orange-500">{opt.price}</span>}
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
